import React, { useState, useEffect } from 'react'
import { Search, Plus, Edit, Trash2, Mail, Phone } from 'lucide-react'
import { userService } from '../services'
import ProfileAvatar from '../components/ProfileAvatar'
import './Users.css'

const Users = () => {
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(true)
  const [searchTerm, setSearchTerm] = useState('')

  useEffect(() => {
    userService.getUsers().then(setUsers).catch(() => setUsers([])).finally(() => setLoading(false))
  }, [])

  const filteredUsers = users.filter(user => {
    const isVendor = (user.role || '').toLowerCase() === 'vendor'
    if (isVendor) return false

    const search = searchTerm.toLowerCase()
    return (
      (user.name || '').toLowerCase().includes(search) ||
      (user.email || '').toLowerCase().includes(search) ||
      (user.role || '').toLowerCase().includes(search)
    )
  })


  return (
    <div className="users-page">
      <div className="page-header">
        <div className="header-titles">
          <h1>Users Management</h1>
          <p>Manage customer accounts and viewing their activity.</p>
        </div>
      </div>

      {/* Search and Filters */}
      <div className="users-controls">
        <div className="search-box">
          <Search size={18} />
          <input
            type="text"
            placeholder="Search users..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      {/* Users Table */}
      <div className="card">
        <div className="table-container">
          {loading ? (
            <p style={{ padding: '2rem' }}>Loading users...</p>
          ) : (
            <table className="table">
              <thead>
                <tr>
                  <th>User</th>
                  <th>Contact</th>
                  <th>Join Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredUsers.map((user) => (
                  <tr key={user.id}>
                    <td>
                      <div className="user-cell">
                        <div className="user-avatar">
                          <ProfileAvatar
                            src={user.profilePhotoUrl ?? user.profile_photo_url}
                            alt={user.name || ''}
                            className="user-avatar-img"
                          />
                        </div>
                        <div>
                          <div className="user-name">{user.name}</div>
                          <div className="user-email">{user.email}</div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="contact-cell">
                        <div className="contact-item">
                          <Mail size={14} />
                          <span>{user.email}</span>
                        </div>
                        <div className="contact-item">
                          <Phone size={14} />
                          <span>{user.phone || user.phoneNumber || '—'}</span>
                        </div>
                      </div>
                    </td>
                    <td>{user.joinDate}</td>
                    <td>
                      <div className="action-buttons">
                        <button className="icon-btn" title="Edit">
                          <Edit size={16} />
                        </button>
                        <button className="icon-btn danger" title="Delete">
                          <Trash2 size={16} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
        {/* Pagination */}
        <div className="pagination">
          <button className="btn btn-secondary">Previous</button>
          <div className="page-numbers">
            <button className="page-number active">1</button>
            <button className="page-number">2</button>
            <button className="page-number">3</button>
          </div>
          <button className="btn btn-secondary">Next</button>
        </div>
      </div>

    </div>
  )
}

export default Users
